var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"textarea",staticClass:"px-3 py-2 w-full bg-white overflow-auto max-h-24",attrs:{"contenteditable":""},on:{"keydown":_vm.handleKeydown,"paste":_vm.pasteText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }